/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Collaborators_Addnewrole2Inputs */

const en_settings_collaborators_addnewrole2 = /** @type {(inputs: Settings_Collaborators_Addnewrole2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new role`)
};

/**
* | output |
* | --- |
* | "Add new role" |
*
* @param {Settings_Collaborators_Addnewrole2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_collaborators_addnewrole2 = /** @type {((inputs?: Settings_Collaborators_Addnewrole2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Collaborators_Addnewrole2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_collaborators_addnewrole2(inputs)
});
export { settings_collaborators_addnewrole2 as "settings_collaborators_addNewRole" }